import { FC, PropsWithChildren, Suspense } from 'react';

import { Spin } from 'antd';

export const LazyComponent: FC<PropsWithChildren> = ({ children }) => {
	return <Suspense fallback={<Spin />}>{children}</Suspense>;
};
